module.exports = {
      id: "Proxiserve-logo-usage",
      viewBox: "0 0 300 68",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Proxiserve-logo-usage",
      toString: function () {
        return this.url;
      }
    }